var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_container"},[_c('el-dialog',{staticClass:"tanchu_dialog",attrs:{"title":_vm.name,"visible":_vm.show,"top":"10vh","append-to-body":""},on:{"close":_vm.dialogClose}},[_c('img',{attrs:{"width":"100%","src":_vm.path,"alt":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8cecf7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/previewImage.vue
// module id = null
// module chunks = 